import React from 'react'
import { useLocation } from 'react-router'

import ButtonLink from '../../../components/display/ButtonLink'
import LazyImage from '../../../components/display/LazyImage'
import BaseHeader from '../../../components/landing/Header'

export const image = {
  medium: {
    width: 620,
    url:
      'https://s3.ap-southeast-2.amazonaws.com/assets.riparide.com/landing_pages/list-with-us/header/medium.jpg',
  },
  large: {
    width: 1200,
    url:
      'https://s3.ap-southeast-2.amazonaws.com/assets.riparide.com/landing_pages/list-with-us/header/large.jpg',
  },
  hero: {
    width: 1300,
    url:
      'https://s3.ap-southeast-2.amazonaws.com/assets.riparide.com/landing_pages/list-with-us/header/hero.jpg',
  },
}

type HeaderCTAProps = {
  search: string
  isInvited?: boolean
}

const HeaderCTA = ({ isInvited, search }: HeaderCTAProps) => {
  const href = isInvited ? `/set-password${search}` : '/my/listings/new'

  return (
    <ButtonLink href={href} rounded>
      Get Started
    </ButtonLink>
  )
}

type HeaderProps = {
  isInvited: boolean
}

const Header = ({ isInvited }: HeaderProps) => {
  const location = useLocation()
  return (
    <BaseHeader
      h2Text={<span>Become a Riparide&nbsp;Host</span>}
      h3Text="Bring your property to life and help people find soul-fulfilling moments in nature."
      cta={<HeaderCTA isInvited={isInvited} search={location?.search} />}
    >
      <LazyImage
        data-src={image.large.url}
        data-srcset={`
            ${image.medium.url} ${image.medium.width}w,
            ${image.large.url} ${image.large.width}w,
            ${image.hero.url} ${image.hero.width}w,
          `}
        preload
      />
    </BaseHeader>
  )
}

export default Header
